/**
 * Toggle the shrunken class on the header when page is scrolled.
 *
 * Styles are applied in site-header.scss, page-hero.scss, and header-main.scss.
 *
 * @return {void}
 */
function toggleShrunkenHeader() {
	const siteHeader = document.querySelector('#masthead');

	if (!siteHeader) {
		return;
	}

	if (window.scrollY > 130) {
		siteHeader.classList.add('shrunken');
	} else if (window.scrollY < 1) {
		siteHeader.classList.remove('shrunken');
	}
}

/**
 * Toggle the visibility of the scroll-to-top button by adding a show class.
 *
 * The scroll-to-top element is in footer.php.
 *
 * @return {void}
 */
function toggleScrollToTop() {
	const scrollToTop = document.querySelector('#scroll-to-top');

	if (!scrollToTop) {
		return;
	}

	const viewportHeight = window.innerHeight;
	if (window.scrollY > viewportHeight) {
		scrollToTop.classList.add('show');
	} else {
		scrollToTop.classList.remove('show');
	}
}

/**
 * Header Observer
 *
 * Set the site-header-height CSS variable to the height of the header element.
 * Add a class to the body when the user scrolls down the page.
 *
 * @return {void}
 */
function scrollObserver() {
	toggleShrunkenHeader();
	toggleScrollToTop();

	window.addEventListener('scroll', function () {
		toggleShrunkenHeader();
		toggleScrollToTop();
	});
}

export { scrollObserver };
